import { gql } from "@apollo/client";

import { userProfileFragment } from "../fragments";

export const getUserProfile = gql`
    query userProfile {
        getUserProfile {
            ...UserProfile
        }
    }
    ${userProfileFragment}
`;
